import { words, isEmpty } from 'lodash';

const acronym = (string) => {
  const separatedNames = words(string);

  const lastIndex = separatedNames.length - 1;
  return !isEmpty(separatedNames)
    ? separatedNames[0].slice(0, 1) +
        (separatedNames.length >= 2 ? separatedNames[lastIndex].slice(0, 1) : '')
    : '';
};

export default acronym;



// WEBPACK FOOTER //
// ./src/utils/acronym.js